import { PostPermission } from "@/modules/types/postPermissionType";

/**
 * サイトのログイン状態に関するUtilクラス。
 */
export default class LoginUtil {
	/**
	 * サイトにログインしているかどうかを判定する。
	 * @param siteUserId サイトログインID
	 * @param nonMemberIdList 非会員IDリスト
	 * @return `true`:ログインしている/`false`ログインしていない
	 */
	public static isLogin(siteUserId: string | null | undefined, nonMemberIdList: string[]): boolean {
		// サイトログインIDはログインしていないと文字が入らないはずなので、サイトログインIDが空文字かどうかで判定する
		if (siteUserId === undefined || siteUserId === null) {
			return false;
		}
		if (siteUserId === "") {
			return false;
		}
		if (nonMemberIdList.includes(siteUserId)) {
			return false;
		}
		return true;
	}

	/**
	 * SiteUserIdをAPIにPost出来る条件かどうかを判定します
	 * @param siteUserId サイトログインID
	 * @param nonMemberIdList 非会員IDリスト
	 * @param postPermissionType 投稿許可設定
	 * @return `true`:送信可能/`false`送信不可
	 */
	public static canSendSiteUserId(siteUserId: string | null | undefined, nonMemberIdList: string[], postPermissionType: string): boolean {
		// 全員投稿可能な場合、ログイン済みでないならSiteUserIdは送信不可とする
		//（非会員が全員同じ扱いになるのを避けるため、Cookieでの個人識別をAPIに強要する）
		if (postPermissionType === PostPermission.all) {
			if (!this.isLogin(siteUserId, nonMemberIdList)) {
				return false;
			}
		}

		return true;
	}
}
